import React, { useEffect, useState } from 'react';
import { FaRegEdit, FaRegTrashAlt } from "react-icons/fa";
import { Modal, Label, TextInput, Checkbox, Button, Table, Select } from 'flowbite-react';
import { toast } from 'react-toastify'; // assuming you're using react-toastify for notifications
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function Employees() {

    // user token for API request
    const token = JSON.parse(window.localStorage.getItem("auth"))?.token;

    // userDatail  for API request
    const userDetail = JSON.parse(window.localStorage.getItem("auth"))?.user;

    const [existingEmployees, setExistingEmployees] = useState([]);
    const [newEmployeeData, setNewEmployeeData] = useState({});
    const [employeeCreateModal, setEmployeeCreateModal] = useState(false);
    const [employeeEditModal, setEmployeeEditModal] = useState(false);
    const [existingEditEmployee, setExistingEditEmployee] = useState({});
    const [updatedEmployeeData, setUpdatedEmployeeData] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    // const [assignedShops, setAssignedShops] = useState([]);
    // const [availableShops, setAvailableShops] = useState([]);

    const navigate = useNavigate();

    useEffect(() => {
        if (userDetail && userDetail.userRole !== 'Admin') {
            navigate('/buying-currency');
        }
    }, [])

    useEffect(() => {
        if (userDetail && userDetail.userRole === 'Admin' && userDetail.shopId === undefined) {
            navigate('/shopSelection');
        }
    }, [])

//     // Add this useEffect to fetch available shops
//     useEffect(() => {
//         const fetchShops = async () => {
//             try {
//                 const response = await axios.get(process.env.REACT_APP_API_URL + 'getShops', {
//                     headers: {
//                         Authorization: `Bearer ${token}`
//                     }
//                 });
//                 setAvailableShops(response.data);
//                 console.log('responseData:', response.data);
//             } catch (error) {
//                 console.error('Error fetching shops:', error);
//             }
//         };
//         fetchShops();
//     }, []);

//     const handleRoleChange = (e) => {
//     setNewEmployeeData({
//         ...newEmployeeData,
//         [e.target.name]: e.target.value,
//         assignedShops: e.target.value === 'admin' ? [] : undefined
//     });
// };

//     // Add this function to handle shop assignment
//     const handleShopAssignment = (e) => {
//         const selectedShop = availableShops.find(shop => shop._id === e.target.value);
//         if (selectedShop && !newEmployeeData.assignedShops?.find(shop => shop._id === selectedShop._id)) {
//             setNewEmployeeData({
//                 ...newEmployeeData,
//                 assignedShops: [...(newEmployeeData.assignedShops || []), selectedShop]
//             });
//         }
//     };

//     // Modify the removeAssignedShop function
//     const removeAssignedShop = (shopId) => {
//         setNewEmployeeData({
//             ...newEmployeeData,
//             assignedShops: (newEmployeeData.assignedShops || []).filter(shop => shop._id !== shopId)
//         });
//     };

    const fetchEmployees = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API_URL + `getShopUsers`, {
                params: {
                    shopId: userDetail?.shopId
                },
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            const employees = response.data;
            // rates.AUD = 1;
            setExistingEmployees(employees);

            // console.log('shops:', existingShops)
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchEmployees();
    }, [])

    const createNewEmployee = async () => {
        try {
            setIsLoading(true);
            const employeeData = {
                ...newEmployeeData,
                shop: userDetail?.shopId,
                // Extract just the shop IDs for the API request
                shops: newEmployeeData.role === 'admin' ?
                    newEmployeeData.assignedShops?.map(shop => shop._id) :
                    []
            };

            const response = await axios.post(
                process.env.REACT_APP_API_URL + 'register',
                employeeData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            if (response.status === 201) {
                setEmployeeCreateModal(false);
                toast.success("User Registered Successfully");
                setNewEmployeeData({}); // Reset form
                fetchEmployees();
            }
            setIsLoading(false);
        } catch (error) {
            toast.error('Error: User Not Created.');
            setIsLoading(false);
        }
    };

    const handleEditEmployee = async (existingEmployee) => {
        setExistingEditEmployee(existingEmployee);
        setEmployeeEditModal(val => !val)
    }

    const updateEmployee = async (id) => {
        try {
            const response = await axios.post(process.env.REACT_APP_API_URL + `updateUserInfo`, {
                userId: id,
                ...updatedEmployeeData
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.status === 201) {
                setEmployeeEditModal(val => !val)
                toast.success('User Updated Successfully.');
            }
            fetchEmployees();
        } catch (error) {
            toast.error('Error: User Not Updated.');
        }
    }

    const handleDeleteEmployee = async (id) => {
        try {
            // Show confirmation toast with styled buttons
            const confirmDelete = await new Promise((resolve) => {
                toast(
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center', // Ensure vertical centering
                        textAlign: 'center', // Center the text
                        padding: '20px', // Add some padding around the content
                    }}>
                        <FaRegTrashAlt size={30} style={{
                            marginBottom: '10px',
                            color: '#FF6347'
                        }} />
                        <span style={{
                            fontSize: '16px',
                            fontWeight: '500',
                            marginBottom: '20px',
                            color: '#333'  // Adjust text color for better readability
                        }}>
                            Are you sure you want to delete this Employee?
                        </span>
                        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                            {/* Yes Button */}
                            <button
                                onClick={() => {
                                    resolve(true);  // Resolve with true when Yes is clicked
                                    toast.dismiss(); // Close the toast
                                }}
                                style={{
                                    backgroundColor: '#05407F', // Red for Yes
                                    color: 'white',
                                    border: 'none',
                                    padding: '10px 20px',
                                    borderRadius: '5px',
                                    fontSize: '14px',
                                    cursor: 'pointer',
                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                    transition: 'background-color 0.3s',
                                }}
                            >
                                Yes, Delete
                            </button>

                            {/* No Button */}
                            <button
                                onClick={() => {
                                    resolve(false);  // Resolve with false when No is clicked
                                    toast.dismiss(); // Close the toast
                                }}
                                style={{
                                    backgroundColor: '#ccc', // Gray for No
                                    color: 'black',
                                    border: 'none',
                                    padding: '10px 20px',
                                    borderRadius: '5px',
                                    fontSize: '14px',
                                    cursor: 'pointer',
                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                    transition: 'background-color 0.3s',
                                }}
                            >
                                No, Keep
                            </button>
                        </div>
                    </div>,
                    {
                        position: "top-center",
                        autoClose: false,  // Prevent auto close
                        hideProgressBar: true,  // Hide progress bar
                        closeOnClick: false,  // Prevent clicking outside to close
                        className: 'delete-toast',  // Optionally add custom class for styling
                    }
                );
            });

            if (confirmDelete) {
                // Proceed with deletion if the user confirms
                const response = await axios.post(
                    process.env.REACT_APP_API_URL + `deleteUser`,  // API URL for deletion
                    { userId: id },  // Send Employee ID in the request body
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,  // Authorization header
                        },
                    }
                );

                // Handle the response
                if (response.status === 200) {
                    toast.success('Employee Deleted Successfully.');
                    fetchEmployees();  // Fetch updated Employee list
                }
            } else {
                toast.info('Employee deletion was canceled.');  // Inform the user if canceled
            }

        } catch (error) {
            toast.error('Error: Employee Not Deleted.');  // Show error if something goes wrong
        }
    };

    return (
        <div className="container mx-auto p-5 space-y-10 flex flex-col">
            <div className="">
                <div className="">
                    {/* <h1 className="text-headings text-3xl font-medium mt-10">Foreign Currency Balance</h1> */}
                </div>
                <div className="flex justify-between mb-4">
                    <h1 className="text-headings text-3xl font-medium ">Employees</h1>
                    <Button className="w-52 bg-theme-secondary" onClick={() => setEmployeeCreateModal(val => !val)}>Add Employee</Button>
                </div>
                <div className="h-[400px] overflow-x-auto bg-gray-50 dark:bg-gray-900 rounded-lg shadow-md">
                    {existingEmployees && existingEmployees.length > 0 ? (
                        <div>
                            <Table className="h-[400px]">
                                <Table.Head className="sticky top-0 z-10 bg-theme-secondary">
                                    <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-base'>#</Table.HeadCell>
                                    <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-base'>Name</Table.HeadCell>
                                    <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-base'>Email</Table.HeadCell>
                                    <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-base'>Shop</Table.HeadCell>
                                    <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-base'>Action</Table.HeadCell>
                                </Table.Head>
                                <Table.Body className="divide-y">
                                    {existingEmployees && (existingEmployees.map((existingEmployee, index) => (
                                        <Table.Row key={index} className="bg-slate-200  dark:border-gray-700 dark:bg-gray-800  ">
                                            <Table.Cell className="font-semibold text-lg text-left ">&nbsp;&nbsp;&nbsp;&nbsp;{index + 1}</Table.Cell>
                                            <Table.Cell className="font-semibold text-lg text-left ">&nbsp;&nbsp;&nbsp;&nbsp;{existingEmployee.name}</Table.Cell>
                                            <Table.Cell className="font-semibold text-lg text-left ">&nbsp;&nbsp;&nbsp;&nbsp;{existingEmployee.email}</Table.Cell>
                                            <Table.Cell className="font-semibold text-lg text-left ">&nbsp;&nbsp;&nbsp;&nbsp;{existingEmployee.shopName}</Table.Cell>
                                            <Table.Cell className="font-semibold text-lg text-left ">&nbsp;&nbsp;&nbsp;&nbsp;
                                                <button className={`border-0 w-7 rounded p-1 bg-#ff7675 text-green-500 hover:text-white hover:font-bold hover:bg-green-500`} onClick={() => handleEditEmployee(existingEmployee)} ><FaRegEdit className={``} /></button>
                                                <button className={`border-0 w-7 ml-1 rounded p-1 bg-#ff7675 text-red-500 hover:text-white hover:font-bold hover:bg-red-500`} onClick={() => handleDeleteEmployee(existingEmployee._id)} ><FaRegTrashAlt className={``} /></button>
                                            </Table.Cell>
                                        </Table.Row>
                                    )))}
                                </Table.Body>
                            </Table>
                        </div>
                    ) : (
                        <div>
                            <div>
                                <h1 className='text-[2rem] text-center mt-10 text-black'>Nothing to Show</h1>
                            </div>
                        </div>
                    )}

                </div>

                {/* Flowbite Modal for Create Employee */}
                <Modal dismissible size='lg' show={employeeCreateModal} onClose={() => setEmployeeCreateModal(false)} setNewEmployeeData={setNewEmployeeData} createNewEmployee={createNewEmployee} >
                    <Modal.Header>Add New Employee</Modal.Header>
                    <Modal.Body>
                        <div className="flex max-w-md flex-col gap-3 mx-auto" >
                            <div className="mb-1">
                                <h2 className="text-center text-[#063A73] font-bold text-[2rem]">Employee Details</h2>
                            </div>

                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="Name" value="Name" />
                                </div>
                                <TextInput
                                    name="name"
                                    type="text"
                                    placeholder="Enter Your Employee Full Name"
                                    // value={name}
                                    onChange={(e) => setNewEmployeeData({
                                        ...newEmployeeData, [e.target.name]: e.target.value
                                    })}
                                    required
                                    shadow
                                />
                            </div>

                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="email" value="Email" />
                                </div>
                                <TextInput
                                    name="email"
                                    type="email"
                                    placeholder="Enter Employee Email Address"
                                    // value={email}
                                    onChange={(e) => setNewEmployeeData({
                                        ...newEmployeeData, [e.target.name]: e.target.value
                                    })}
                                    required
                                    shadow
                                />
                            </div>

                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="role" value="User Role" />
                                </div>
                                <Select name="role" onChange={(e) => setNewEmployeeData({ ...newEmployeeData, [e.target.name]: e.target.value })} required shadow >
                                    <option value='User' selected>User</option>
                                    <option value='Admin' >Admin</option>
                                </Select>
                            </div>

                            {/* <div className={`${newEmployeeData.role === 'admin' ? '' : 'hidden'}`}>
                                <div className="mb-2 block">
                                    <Label htmlFor="shops" value="Assign Shop" />
                                </div>
                                <Select
                                    name="shop"
                                    onChange={handleShopAssignment}
                                    required
                                    shadow
                                >
                                    <option value="" selected disabled>Select Shop</option>
                                    {availableShops.map(shop => (
                                        <option key={shop._id} value={shop._id}>
                                            {shop.name}
                                        </option>
                                    ))}
                                </Select>
                            </div> */}

                            {/* <div className={`${newEmployeeData.role === 'admin' ? '' : 'hidden'}`}>
                                <div className="mb-2 block">
                                    <Label htmlFor="assignedShops" value="Assigned Shops" />
                                </div>
                                <div className="flex flex-wrap gap-2 p-2 border rounded-lg min-h-[50px]">
                                    {newEmployeeData.assignedShops?.map(shop => (
                                        <div
                                            key={shop._id}
                                            className="flex items-center gap-2 px-3 py-1 bg-blue-100 text-blue-800 rounded-full"
                                        >
                                            <span>{shop.name}</span>
                                            <button
                                                type="button"
                                                onClick={() => removeAssignedShop(shop._id)}
                                                className="text-blue-600 hover:text-blue-800 font-bold"
                                            >
                                                ×
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div> */}

                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="password" value="Password" />
                                </div>
                                <TextInput
                                    name="password"
                                    type="password"
                                    placeholder="Enter Password"
                                    onChange={(e) => setNewEmployeeData({
                                        ...newEmployeeData, [e.target.name]: e.target.value
                                    })}
                                    required
                                    shadow
                                />
                            </div>
                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="confirmPassword" value="Confirm Password" />
                                </div>
                                <TextInput
                                    name="confirmPassword"
                                    type="password"
                                    placeholder="Confirm Password"
                                    onChange={(e) => setNewEmployeeData({
                                        ...newEmployeeData, [e.target.name]: e.target.value
                                    })}
                                    onBlur={() => {
                                        if (newEmployeeData.password !== newEmployeeData.confirmPassword) {
                                            toast.error('Password doesnt matched');
                                        }
                                    }}
                                    required
                                    shadow
                                />
                            </div>

                            <button onClick={createNewEmployee}
                                disabled={!newEmployeeData.name || !newEmployeeData.email || !newEmployeeData.password || !newEmployeeData.confirmPassword || newEmployeeData.password !== newEmployeeData.confirmPassword}
                                className="bg-gradient-to-br from-theme-primary to-theme-secondary text-white py-2 rounded-lg">

                                Add Employee
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>

                {/* Flowbite Modal for Edit Shop */}
                <Modal dismissible size='lg' show={employeeEditModal} onClose={() => setEmployeeEditModal(false)} existingEditEmployee={existingEditEmployee} setUpdatedEmployeeData={setUpdatedEmployeeData} updateEmployee={updateEmployee} >
                    <Modal.Header>Edit Employee Info</Modal.Header>
                    <Modal.Body>
                        <div className="flex max-w-md flex-col gap-3 mx-auto" >
                            <div className="mb-1">
                                <h2 className="text-center text-[#063A73] font-bold text-[2rem]">Edit Employee</h2>
                            </div>

                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="Name" value="Name" />
                                </div>
                                <TextInput
                                    name="name"
                                    type="text"
                                    placeholder="Enter Your Employee Full Name"
                                    defaultValue={existingEditEmployee.name}
                                    onChange={(e) => setUpdatedEmployeeData({
                                        ...updatedEmployeeData, [e.target.name]: e.target.value
                                    })}
                                    required
                                    shadow
                                />
                            </div>

                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="email" value="Email" />
                                </div>
                                <TextInput
                                    name="email"
                                    type="email"
                                    placeholder="Enter Employee Email"
                                    defaultValue={existingEditEmployee.email}
                                    onChange={(e) => setUpdatedEmployeeData({
                                        ...updatedEmployeeData, [e.target.name]: e.target.value
                                    })}
                                    required
                                    shadow
                                />
                            </div>
                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="newPassword" value="New Password" />
                                </div>
                                <TextInput
                                    name="newPassword"
                                    type="password"
                                    placeholder="Enter New Password"
                                    onChange={(e) => setUpdatedEmployeeData({
                                        ...updatedEmployeeData, [e.target.name]: e.target.value
                                    })}
                                    required
                                    shadow
                                />
                            </div>
                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="confirmNewPassword" value="Confirm New Password" />
                                </div>
                                <TextInput
                                    name="confirmNewPassword"
                                    type="password"
                                    placeholder="Confirm New Password"
                                    onChange={(e) => setUpdatedEmployeeData({
                                        ...updatedEmployeeData, [e.target.name]: e.target.value
                                    })}
                                    onBlur={() => {
                                        if (updatedEmployeeData.newPassword !== updatedEmployeeData.confirmNewPassword) {
                                            toast.error('Password doesnt matched');
                                        }
                                    }}
                                    required
                                    shadow
                                />
                            </div>

                            <button onClick={() => updateEmployee(existingEditEmployee._id)}
                                disabled={updatedEmployeeData.newPassword !== updatedEmployeeData.confirmNewPassword}
                                className="bg-gradient-to-br from-theme-primary to-theme-secondary text-white py-2 rounded-lg">

                                Update Employee
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>

        </div>
    );
}

export default Employees;

